import { createContext } from 'react';

export const JBErrorContentContext = createContext({
  content: 'Error: page not found',
});
